import { render } from "./RateThisPage.vue?vue&type=template&id=e5baccd8"
import script from "./RateThisPage.vue?vue&type=script&lang=js"
export * from "./RateThisPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__